<template>
  <ProjectDetail
    :projectId="projectId"
    class="content-block"
    @back="onBack"
  ></ProjectDetail>
</template>

<script>
import ProjectDataMixin from 'CORE/mixins/project-data'
import ProjectDetail from 'CORE/components/project/detail'

export default {
    name: 'ProjectDetailView',
    components: {
        ProjectDetail,
    },
    mixins: [
        ProjectDataMixin,
    ],
    props: {
        rootFilter: {
            required: false,
            default: _ => {},
            type: Object,
        },
    },
    computed: {
        projectId() {
            return this.$route.params.id
        },
    },
    methods: {
        onBack() {
            window.history.back(1)
        },
    },
}
</script>
